<script setup>
  import TextAreaComponent from "@/components/form/TextAreaComponent.vue";
  import BasicButtonComponent from "@/components/form/BasicButtonComponent.vue";
  import {computed, ref} from "vue";
import { useBusinessStore } from "@/stores/business";
import { useAuthStore } from "@/stores/auth";

  const props = defineProps({
      review: {
        type: Object,
        default: (() => {

        }),
        required: true
      },
  }),
  authStore = useAuthStore(),
  store = useBusinessStore(),
   isAuthenticated = computed(() => !authStore.guest),
   isOpen = ref(false),
   comment = ref(null),
      showComment = ref(false),
   saveComment = () => {
    if (comment.value === null) return alert("Comment can't be empty");
     store.addComment({
       review_id: props.review.id,
       content: comment.value,
     }).then(() => {
       if (store.error) return alert(store.error);
       alert("Comment added successfully");
       comment.value = null
       isOpen.value = false
     })
   }
</script>

<template>
  <button
    v-if="props.review.commentCount > 0"
    class="text-xs text-gray-500 hover:text-gray-700 flex items-center justify-center w-full"
    @click="showComment = !showComment"
  >
    {{ showComment ? 'Hide' : 'Show' }} replies {{ props.review.commentCount }}
  </button>
  <basic-button-component
    v-if="isAuthenticated"
    id="reply-to-review"
    class="block ml-auto shadow-none text-xs text-green-500 pb-4"
    :data-id="props.review.id"
    data-toggle="modal"
    data-target="#NotLoggedInModal"
    @click="isOpen = true"
  >
    Reply
  </basic-button-component>
  <router-link
    v-else
    :to="{ name: 'Login' }"
    data-toggle="modal"
    data-target="#NotLoggedInModal"
    class="block text-right shadow-none p-0 text-sm text-green-500"
  >
    Login to reply
  </router-link>
  <form
    :id="`comment-form-${props.review.id }`"
    :class="[
      isOpen ? 'block transition-all' : 'hidden transition-all',
      'comment-form px-4 pb-3'
    ]"
    @submit.prevent="saveComment"
  >
    <text-area-component
      id="comment"
      v-model:textarea-value="comment"
      name="comment"
      placeholder="Enter comment"
      class="border"
      row="2"
    />
    <div class="mt-3 text-right flex-1 flex space-x-3 justify-end items-center">
      <basic-button-component
        :id="`cancel-comment-btn-${props.review.id }`"
        type="button"
        class="text-sm text-gray-500 font-semibold border border-gray-500 hover:text-gray-50 hover:bg-gray-500 transition-all shadow-md hover:shadow-none"
        @click="isOpen = false"
      >
        Cancel
      </basic-button-component>
      <basic-button-component
        :id="`submit-comment-btn-${props.review.id }`"
        type="submit"
        class="text-sm border font-semibold border-green-500 text-green-500 hover:text-green-50 hover:bg-green-500 transition-all shadow-md hover:shadow-none"
      >
        Reply
      </basic-button-component>
    </div>
  </form>

  <div
    class="mb-4"
    :class="{ 'hidden' : !showComment }"
  >
    <ul>
      <li
        v-for="(reply, index) in props.review.comments"
        :key="reply.id"
        :class="['p-4 rounded-xl bg-gray-50', index === props.review.comments.length - 1 ? '' : 'border-b mb-2']"
      >
        <div class="text-left text-[13px] text-gray-500">
          <p class="text-gray-500">
            {{ reply.content }}
          </p>
        </div>
        <div class="flex justify-between items-center mt-3 border-t pt-3">
          <div class="flex flex-1 space-x-3 items-center">
            <img
              :src="reply.commentedBy.avatar"
              alt="props.review-name"
              class="rounded-full h-8 w-8"
            >
            <span class="text-xs text-gray-400 drop-shadow">{{ reply.commentedBy.name }}</span>
          </div>
          <span class=" text-xs text-gray-400 drop-shadow">{{ reply.createdAt }}</span>
        </div>
      </li>
    </ul>
  </div>
</template>

<style scoped>

</style>
